import React from 'react';
import { Camera, Picture } from '../../Icons';

const PhotoButton = ({ text, icon, onClick }) => {
  const Icon = icon === 'camera' ? Camera : icon === 'picture' ? Picture : null;
  return (
    <button
      className='btn btn-block py-7 bg-gray-light font-weight-normal d-flex align-items-center text-nowrap justify-content-center'
      onClick={onClick}
    >
      {Icon && <Icon className='mr-5' />}
      {text}
    </button>
  );
};

export default PhotoButton;
